import React from "react";

const LanguageTranslation = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-8">Language Translation</h1>
      <p className="text-gray-400 max-w-2xl text-center">
        Translate text into multiple languages in real-time. Paste your text below and select your target language.
      </p>
      <textarea
        className="mt-4 w-full max-w-2xl bg-gray-800 text-white p-4 rounded-lg"
        rows={6}
        placeholder="Enter text to translate..."
      ></textarea>
      <button className="mt-4 px-6 py-3 bg-gradient-to-r from-purple-400 to-blue-400 text-white font-bold rounded-lg shadow-lg">
        Translate
      </button>
    </div>
  );
};

export default LanguageTranslation;